<template lang="pug">
  v-snackbar(v-model="getNotification.status" :multi-line="multiLine")  {{getNotification.message}}
    v-btn(@click="resetNotificationStatus()" color="red"  text)
      v-icon mdi-close
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
    name: "NotificationSnackbar",
    data () {
      return {
        color: '',
        mode: '',
        multiLine:true,
        x: null,
        y: 'top',
      }
    },
    computed: {
      ...mapGetters([
          'getNotification'
        ]),
    },
    methods:{
      resetNotificationStatus: function () {
        this.$store.state.notification.status = false;
      }
    }
  }
</script>

<style lang="sass">
</style>